<template>
  <div id="memberPopup">
    <div class="common_view_tit">회원 정보</div>
    <div class="common_view_list">
      <div class="common_view_item">
        <div>
          <div>이름</div>
          <div>{{userName}}</div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>본부</div>
          <div>
            {{afcName}}
            {{ofc1Name}}
            {{ofc2Name}}
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>전화번호</div>
          <div>{{telephone}}</div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>이동전화번호</div>
          <div>{{mobilePhone}}</div>
        </div>
      </div>
    </div>
<!--    <div class="common_bottom_wrap padding_wrap">-->
<!--      <div class="btn_bottom btn_close" @click="hidePopup">닫기</div>-->
<!--      <div class="btn_bottom btn_blue_t">등록(선택)</div>-->
<!--    </div>-->
  </div>
</template>

<script>
import common from '../../script/common'

export default {
  props: ['popupParams'],
  data () {
    return {
      // Common Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc2List: [],
      // Data
      selectedItem: {},
      registerInfo: {},
      userName: '',
      afcName: '',
      ofc1Name: '',
      ofc2Name: '',
      telephone: '',
      mobilePhone: ''
    }
  },
  mounted () {
    this.selectedItem = this.popupParams.data
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.ofc2List = this.getOfc2List()
            this.getUserInfo()
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  watch: {
    popupParams () {
      this.selectedItem = this.popupParams.data
    }
  },
  methods: {
    hidePopup () {
      this.$emit('hidePopup')
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List () {
      return this.ofcList.filter(item => { return item.codeLevel === 1 })
    },
    getUserInfo () {
      const data = this.selectedItem
      this.userName = data.userName
      this.telephone = data.telephone
      this.mobilePhone = data.mobilePhone
      if (this.popupParams.from === 'AS' || this.popupParams.from === 'STOP' || this.popupParams.from === 'CANCEL') {
        this.userName = this.popupParams.userType === 'R' ? data.userName : data.procUserName
        this.telephone = this.popupParams.userType === 'R' ? data.telephone : data.procTelephone
        this.mobilePhone = this.popupParams.userType === 'R' ? data.mobilePhone : data.procMobilePhone
      } else if (this.popupParams.from === 'SQ') {
        this.userName = this.popupParams.userType === 'R' ? data.userName : this.popupParams.userType === 'A' ? data.qmUserName : data.qrUserName
        this.telephone = this.popupParams.userType === 'R' ? data.telephone : this.popupParams.userType === 'A' ? data.qmTelephone : data.qrTelephone
        this.mobilePhone = this.popupParams.userType === 'R' ? data.mobilePhone : this.popupParams.userType === 'A' ? data.qmMobilePhone : data.qrMobilePhone
      }
      this.afcName = ''
      this.ofc1Name = ''
      this.ofc2Name = ''
      if (data.affiliateCode != null) {
        for (let i = 0; i < this.afcList.length; i++) {
          if (this.afcList[i].codeValue === data.affiliateCode) {
            this.afcName = this.afcList[i].codeName
          }
        }
      }
      if (data.officeCode != null) {
        for (let i = 0; i < this.ofc1List.length; i++) {
          if (this.ofc1List[i].codeValue === data.officeCode.substring(0, 5)) {
            this.ofc1Name = this.ofc1List[i].codeName
          }
        }
        if (data.officeCode.length > 5) {
          for (let i = 0; i < this.ofc2List.length; i++) {
            if (this.ofc2List[i].codeValue === data.officeCode) {
              this.ofc2Name = this.ofc2List[i].codeName
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
#memberPopup .common_bottom_wrap > .btn_bottom {
  height: 46px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}

#memberPopup .common_bottom_wrap > .btn_close {
  width: 76px;
  margin: auto auto auto 0;
  color: #36414F;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MemberPopup.vue